import { useState } from "react";

export function UrlImporter({ onImport }: { onImport: (url: string) => void }) {
  const [url, setUrl] = useState("");
  return (
    <div className="row">
      <input
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        placeholder="https://example.com/reference.png"
      />
      <button onClick={() => { if (url.trim()) onImport(url.trim()); setUrl(""); }}>Import</button>
    </div>
  );
}
